import { createSlice } from '@reduxjs/toolkit';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { getAllVendors, updateVendor } from './vendorAPI';
import { getUserWallet } from '../../../api/walletAPI';

export const vendorSlice = createSlice({
  name: 'vendor',
  initialState: {
    vendors: [],
    status: 'idle',
    searchValue: '',
    vendorDeliveryRateModalOpen: false,
    editVendorModalOpen: false,
    adminTopUpModalOpen: false,
    walletTransactionModalOpen: false,
    pagination: {},
    page: 0,
    rowsPerPage: 100,
    selectedId: null,
    selectedUserId: null,
    selectedWalletId: null,
    walletsByUserId: {}
  },
  reducers: {
    openVendorDeliveryRateModal: (state) => {
      state.vendorDeliveryRateModalOpen = true;
    },
    closeVendorDeliveryRateModal: (state) => {
      state.vendorDeliveryRateModalOpen = false;
    },
    openEditVendorModal: (state) => {
      state.editVendorModalOpen = true;
    },
    closeEditVendorModal: (state) => {
      state.editVendorModalOpen = false;
    },
    openAdminTopUpModal: (state) => {
      state.adminTopUpModalOpen = true;
    },
    closeAdminTopUpModal: (state) => {
      state.adminTopUpModalOpen = false;
    },
    openWalletTransactionModal: (state) => {
      state.walletTransactionModalOpen = true;
    },
    closeWalletTransactionModal: (state) => {
      state.walletTransactionModalOpen = false;
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setSelectedUserId: (state, action) => {
      state.selectedUserId = action.payload;
    },
    setSelectedWalletId: (state, action) => {
      state.selectedWalletId = action.payload;
    },
    setWalletForUser: (state, action) => {
      const { userId, wallet } = action.payload;
      state.walletsByUserId[userId] = wallet;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setVendors: (state, action) => {
      state.vendors = action.payload;
      state.status = 'success'
    },
  },
});

export const { openVendorDeliveryRateModal, closeVendorDeliveryRateModal, openEditVendorModal, closeEditVendorModal, openAdminTopUpModal, closeAdminTopUpModal, openWalletTransactionModal, closeWalletTransactionModal, setSelectedId, setSelectedUserId, setSelectedWalletId, setWalletForUser, setPage, setRowsPerPage, setPagination, setVendors, setSearchValue } = vendorSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.vendor.value)`
export const selectState = state => state.vendor;

export const handleGetVendors = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    const response = await getAllVendors(state.vendor.page, state.vendor.rowsPerPage, state.vendor.searchValue);
    const { content, ...pagination } = response.data;

    dispatch(setPagination(pagination));
    dispatch(setVendors(content));
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoading());
  }
};

export const handleFetchVendorWallet = (userId) => async (dispatch, getState) => {
  if (!userId) {
    return null;
  }
  const { vendor } = getState();
  if (vendor.walletsByUserId[userId] !== undefined) {
    return vendor.walletsByUserId[userId];
  }
  try {
    const wallet = await getUserWallet(userId);
    dispatch(setWalletForUser({ userId, wallet }));
    return wallet;
  } catch (error) {
    console.log(error);
    dispatch(setWalletForUser({ userId, wallet: null }));
    return null;
  }
};


export const handleUpdateVendor = (payload, id) => async (dispatch) => {
  dispatch(showLoading());
  try {
    await updateVendor(payload, id);
    dispatch(closeEditVendorModal());
    dispatch(handleGetVendors());
  } finally {
    dispatch(hideLoading());
  }
};

export default vendorSlice.reducer;
